import './uploadView.tpl.html';

angular
  .module('gdprRequest.uploadView', [
    'filters.i18n',
    'services.batch',
    'services.bulkrestore',
    'services.bulkrestoredata',
    'services.error',
    'services.useragent',
    'shared.wizard'
  ])
  /**
   * Controller for the bulkRestore.uploadView template.
   */
  .controller(
    'GdprRequestUploadViewCtrl',
    function (
      $scope,
      $filter,
      $rootScope,
      $state,
      batchUtils,
      httpQueue,
      progressFactory,
      ErrorService,
      UserAgentFactory,
      WizardButtonFactory,
      WizardService,
      httpGdprRequest,
      GdprRequestService
    ) {
      if (!$state.params.gdprRequestData) {
        throw new Error('gdprRequestData is required');
      }

      const i18n = $filter('i18n');
      const bulkRestoreData = $state.params.bulkRestoreData;
      let touched, model;

      // Published functions
      $scope.shouldShowUploadInstructions = shouldShowUploadInstructions;
      $scope.uploadFile = uploadFile;

      $scope.gdprRequestData = $state.params.gdprRequestData;

      // Store data in a model object rather than the scope itself for easier watching
      $scope.model = model = {
        hasUploadFile: false,
        touched: true,
        uploadFile: undefined,
        uploadSupported: !UserAgentFactory.isIE9()
      };

      initWizardPage();
      watchUploadFile();

      /**
       * Determines whether there are enough backups to run a restore.
       *
       * @returns {boolean} true if there are enough backups.
       */
      function hasEnoughBackups() {
        return batchUtils.backupBatchDots.count > 1;
      }

      /**
       * Sets up this page for use with the wizard service.
       */
      function initWizardPage() {
        // Register our page with the wizard service
        const page = WizardService.getCurrentPage();
        page.setHeaderText(i18n('UPLOAD_CSV'));
        page.setStateParams($state.params);
        page.setTouched(() => touched);
        page.setValid(() => $scope.model.hasUploadFile);
      }

      /**
       * Determines whether to display the instructions for upload.
       *
       * @returns {boolean} true if the upload instructions are to be shown.
       */
      function shouldShowUploadInstructions() {
        return model.uploadSupported && !$scope.showMaskWithDashboardButton;
      }

      /**
       * Function to upload CSV file to s3 and queue message.
       *
       * @returns {Promise} a promise that is resolved with one of the following:
       *   1) true if the wizard can be dismissed
       *   2) false if the wizard should remain
       *   3) an object containing the parameters to pass to the wizard cancel function to display an error message.
       */
      function uploadFile() {
        $rootScope.showLoadingMask = true;

        // Do the upload.
        let uploaded = false;
        const timestamp = new Date().getTime();

        return GdprRequestService.getPreSignedPostUrl(timestamp)
          .then((url) => httpGdprRequest.uploadFileToUrl(url, model.uploadFile))
          .then((timestamp) => {
            // When the verification starts successfully, switch to the dashboard mask
            $rootScope.showLoadingMask = false;

            touched = false;

            return false; // Don't close the wizard yet since we're allowing the user to wait here.
          })
          .catch((err) => {
            $rootScope.showLoadingMask = false;

            // We're back to needing confirmation to exit
            touched = true;

            ErrorService.report(i18n('UPLOAD_FILE_ERROR'));

            return false; // Stay in the wizard since something went wrong
          });
      }

      /**
       * Watches for a change to the selected CSV file.
       */
      function watchUploadFile() {
        $scope.$watch(
          () => model.uploadFile,
          (newVal) => {
            if (newVal) {
              $scope.gdprRequestData.setUploadFile(model.uploadFile);
            }
          }
        );
      }
    }
  );
